<template>
  <div class="page-wrapper rep-analytics-wrap">
    <div class="container-fluid">
      <breadcrumb :items="breadcrumbItems" />
      <div class="page-title split rep-analysis-title justify-content-between">
        <div class="">
        <h1 v-if="selectedGroupId" class="mb-0">Group Analytics</h1>
        <h1 v-else class="mb-0">Rep Analytics</h1>
        </div>
        <div class="rep-selector">
          <rep-selector />
        <div class="d-flex align-items-center gap-2 direct-grp">
          <label class="form-label mb-0 fit-content">Downline Group</label>
          <multiselect name="group" v-model="selectedGroupId" placeholder="Select Group"
            :options="groups.map((type) => type.group_id)"
            :custom-label="(opt) => groups.find((x) => x.group_id == opt).group_name" :options-limit="100"
            :internal-search="false" :local-search="false" @search-change="searchHandler" @open="getGroups" />
        </div>
        </div>
      </div>
      <br />
      <div class="downline">
        <div class="page-title">
          <h5 v-if="selectedGroupId">{{ groupAnalyticsTitle }} [ Downline Group ]</h5>
          <h5 v-else>Downline Analytics</h5>
        </div>
        <div class="row mb-3">
          <div class="col-md-7">
            <DwNewMembersByMonth @hide-loader="updateFlag" :groupId="selectedGroupId" />
          </div>
          <div class="col-md-5">
            <div class="row">
              <DwOverallTotals @hide-loader="updateFlag" :groupId="selectedGroupId" />
            </div>
            <br />
            <div class="row">
              <DwOverallTotalMembers @hide-loader="updateFlag" :groupId="selectedGroupId" />
            </div>
          </div>
        </div>
        <div class="row mb-5">
          <div class="col-md-7">
            <DwEnrollmentsByMonth @hide-loader="updateFlag" :groupId="selectedGroupId" />
          </div>
          <div class="col-md-5">
            <DwOverallTotalPolicies @hide-loader="updateFlag" :groupId="selectedGroupId" />
          </div>
          <div class="col-12">
            <DwEnrollmentsTermsOverview @hide-loader="updateFlag" :groupId="selectedGroupId" />
          </div>
        </div>
        <div class="row mb-3 rep-analytics-third">
          <div class="col-md-7">
            <DwTotalMembersByIndividualPlan @hide-loader="updateFlag" :groupId="selectedGroupId" />
          </div>
          <div class="col-md-5">
            <div class="row">
              <DwTotalActiveByState @hide-loader="updateFlag" :groupId="selectedGroupId" />
            </div>
            <br />
            <div class="row">
              <DwTotalMembersByPlan @hide-loader="updateFlag" :groupId="selectedGroupId" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <member-plan-modal /> -->
  </div>
</template>
<script>
import DwOverallTotals from "./DownlinesAnalytics/DwOverallTotals.vue";
import DwOverallTotalMembers from "./DownlinesAnalytics/DwOverallTotalMembers.vue";
import DwNewMembersByMonth from "./DownlinesAnalytics/DwNewMembersByMonth.vue";
import DwEnrollmentsByMonth from "./DownlinesAnalytics/DwEnrollmentsByMonth.vue";
import DwOverallTotalPolicies from "./DownlinesAnalytics/DwOverallTotalPolicies.vue";
import DwEnrollmentsTermsOverview from "./DownlinesAnalytics/DwEnrollmentsTermsOverview.vue";
import DwTotalMembersByIndividualPlan from "./DownlinesAnalytics/DwTotalMembersByIndividualPlan.vue";
import DwTotalActiveByState from "./DownlinesAnalytics/DwTotalActiveByState.vue";
import DwTotalMembersByPlan from "./DownlinesAnalytics/DwTotalMembersByPlan.vue";
import RepSelector from "./RepSelector.vue";
import Api from "@/resource/Api";

export default {
  name: "RepAnalytics",
  components: {
    DwOverallTotals,
    DwOverallTotalMembers,
    DwNewMembersByMonth,
    DwEnrollmentsByMonth,
    DwOverallTotalPolicies,
    DwEnrollmentsTermsOverview,
    DwTotalMembersByIndividualPlan,
    DwTotalActiveByState,
    DwTotalMembersByPlan,
    RepSelector,
  },
  data() {
    return {
      repAnalytics: {
        dwenrollmentByMonth: false,
        dwenrollmentTermsOverviewByYear: false,
        dwnewMemberByMonth: false,
        dwtotalActiveByState: false,
        dwtotalMembersByIndividualPlan: false,
        dwtotalMembersByPlan: false,
        dwoverallTotals: false,
        dwoverallTotalPolicies: false,
        dwoverallTotalMembers: false,
      },
      isLoading: true,
      loaderIcon: "",
      breadcrumbItems: [{ title: "Rep Downline Analytics", active: true }],
      groups: null,
      selectedGroupId: '',
    };
  },
  computed: {
    groupAnalyticsTitle() {
      if (this.selectedGroupId) {
        const group = this.groups?.find(g => g.group_id === this.selectedGroupId);
        return group ? `${group.group_name} Analytics` : "Direct Analytics";
      }
      return "Direct Analytics";
    }
  },
  methods: {
    searchHandler(query) {
      if (query.length > 2) {
        this.getGroups(query);
      }
    },
    updateFlag(key) {
      // console.log("Emitted From", key);
      this.repAnalytics[key] = true;
      this.loadingStatus();
    },
    getGroups(query = "") {
      let url;
      if (query) {
        url = `v2/rep-analytics/group-list?downline_report=true&size=100&group_name=${query}`;
      } else {
        url = `v2/rep-analytics/group-list?downline_report=true&size=100`;
      }
      Api.get(url).then((res) => {
        this.groups = res.data.data;
      });
    },

    loadingStatus() {
      if (this.isLoading) {
        this.loaderIcon = this.$loading.show();
        this.isLoading = false;
      }
      let flags = Object.values(this.repAnalytics);
      if (flags.every((flag) => flag === true)) {
        this.loaderIcon.hide();
      }
    },
  },

  created() {
    this.getGroups();
    this.loadingStatus();
  },
  watch: {
    selectedGroupId(newVal, oldVal) {
      if (newVal !== oldVal) {
        Object.keys(this.repAnalytics).forEach(key => this.repAnalytics[key] = false);
        this.isLoading = true;
        this.loadingStatus();
      }
    }
  }
};
</script>
<style src="../../assets/css/repanalytics.css"></style>